import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    cursor: none;
  }

  body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background: linear-gradient(135deg, #6B8E23 0%, #556B2F 100%);
    overflow: hidden;
    height: 100vh;
    width: 100vw;
  }

  #root {
    width: 100%;
    height: 100%;
  }
`;
